import { API } from "../store"
import serialize from "../store/serialize"
import handleCatch from "../lib/catch"
import { orderBy } from "lodash"

const iteratees = [o => o.ratings.length, "last_name"]
const orders = ["desc", "asc"]

export const lengthCrew = data => ({
  type: "CREW::LENGTH_PUSH_NEW",
  data,
})

export const clearCrewSearchLength = (searchcrew = []) => ({
  type: "CREW::SET_SEARCH_CREW_LENGTH",
  searchcrew,
})

export const loadingCrew = (loadingCrew = false) => ({
  type: "CREW::PERFORMING_SEARCH",
  loadingCrew,
})

export const loadingCrewFromChip = (loadingCrew = true) => ({
  type: "CREW::PERFORMING_SEARCH_FROM_CHIP",
  loadingCrew,
})

export const setCrew = (crew = []) => ({
  type: "CREW::SET_CREW",
  crew,
})

export const setCrewSearch = (crew = []) => ({
  type: "CREW::SET_CREW_SEARCH",
  crew,
})

export const setCrewLength = (searchcrew = []) => ({
  type: "CREW::SET_SEARCH_CREW_LENGTH",
  searchcrew,
})

export const updateCrewMember = (updates = {}) => ({
  type: "CREW::UPDATE_CREW_MEMBER",
  updates,
})

export const removeCrewMember = (id = "") => ({
  type: "CREW::REMOVE_CREW_MEMBER",
  id,
})

export const clearCrew = () => ({
  type: "CREW::CLEAR_CREW",
})
export const clearCrewFromChip = () => ({
  type: "CREW::CLEAR_CREW_CHIP",
})

export const toggleReferCrewDialog = (referCrewDialogOpen = false) => ({
  type: "CREW::TOGGLE_REFER_CREW_DIALOG",
  referCrewDialogOpen,
})

export const setCrewRating = (userId, rating, avgRating) => ({
  type: "CREW::RATING::SET",
  userId,
  rating,
  avgRating,
})

export const pushCrew = crew => ({
  type: "CREW::PUSH",
  crew,
})

export const setSelectedCrewMember = (id = null) => ({
  type: "CREW::SET_SELECTED_CREW_MEMBER",
  id,
})

// export const lengthCrew = crew => ({
//   type: "CREW::LENGTH_PUSH",
//   crew,
// })

export const sortCrew = (crew, sort) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const currentCrew = crew.splice(0)
      dispatch(clearCrew)
      const newCrew = orderBy(currentCrew, ...sort)
      dispatch(setCrew(newCrew))
      resolve(newCrew)
    })
    return deferred
  }
}

export const searchCrew = (query, bool) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post("/users/search")
        .send(query)
        .then(response => response.body)
        .then(response => {
          !bool && dispatch(loadingCrew(false))
          if (response.message !== "No users found") {
            let searchCrewLength = response.data.searchCrewLength
            serialize("user", response.data.output).then(response => {
              const orderedCrew = orderBy(
                response,
                ["master_rating"].concat(iteratees),
                ["desc"].concat(orders)
              )

              resolve(orderedCrew)
              !bool && dispatch(setCrewSearch(orderedCrew))
              !bool && dispatch(setCrewLength(searchCrewLength))
            })
          } else {
            !bool && dispatch(setCrewLength(0))
            resolve([])
          }
        })
        .catch(err => {
          dispatch(loadingCrew(false))
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getCrewPaginate = (currentPage, postsPerPage) => {
  return dispatch => {
    dispatch(loadingCrew())
    dispatch(clearCrew())
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/users/${currentPage}/${postsPerPage}`)
        .then(response => response.body)
        .then(response => {
          dispatch(loadingCrew(false))
          if (response.message !== "No users found") {
            serialize("user", response.data).then(response => {
              const orderedCrew = orderBy(
                response,
                ["master_rating"].concat(iteratees),
                ["desc"].concat(orders)
              )
              resolve(orderedCrew)
              dispatch(setCrew(orderedCrew))
            })
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const listCrew = currentPage => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/users/listUsers/${currentPage}`)
        .then(response => response.body)
        .then(response => {
          dispatch(loadingCrew(false))
          if (response.message !== "No users found") {
            let searchCrewLength = response.data.searchCrewLength
            serialize("user", response.data.output).then(response => {
              const orderedCrew = orderBy(
                response,
                ["master_rating"].concat(iteratees),
                ["desc"].concat(orders)
              )
              resolve(orderedCrew)
              dispatch(setCrew(orderedCrew))
              dispatch(setCrewLength(searchCrewLength))
            })
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getCrewLength = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/users/getLength/users`)
        .then(response => response.body)
        .then(response => {
          if (response.message !== "No users found") {
            serialize("user", response.data).then(response => {
              resolve(response)
            })
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getCrewForExport = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post(`/export_users_data`)
        .send(data)
        .then(response => response.body)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const sendDeletedShootEmail = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.post(`/send-email`)
        .send(data)
        .then(response => response.body)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

// export const sendDeletedShootEmail = data =>
//   API.post(`/send-email`, data).then(res => res.data)

export const getCrew = crewId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/users/${crewId}`)
        .then(response => response.body)
        .then(response => {
          if (response.message !== "No users found") {
            serialize("user", response.data).then(response => {
              resolve(response)
              dispatch(pushCrew(response))
            })
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const removeFromCompany = (userId, companyId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.delete(`/companies/${companyId}/user/${userId}`)
        .then(response => response.body)
        .then(response => {
          if (response.message === "user removed from company") {
            dispatch(removeCrewMember(userId))
            resolve()
          } else {
            resolve()
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}
